import { createMutation } from '../common';
import * as apis from '../apis';

export const useDeleteDimension = createMutation({
  mutationFn: apis.deleteDimension,
});
